import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-calendar-icon',
    templateUrl: './calendar-icon.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CalendarIconComponent {}
